import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { ecoLeatherPhotos } from '../data/ecoLeather';
export function NewCollection() {
  return <section id="new-collection" className="py-24 bg-brand-dark text-brand-cream overflow-hidden" data-id="element-287" data-mp="2r41r84icdecz">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-288" data-mp="2md3c3893ambb">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-289" data-mp="2mbs3mv4p8qdv">
          {/* Text */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="lg:col-span-4" data-id="element-290" data-mp="2w3elvbfgfpq4">
            <p className="text-sm text-brand-rose mb-4" data-id="element-291" data-mp="3529s2nii0ztf">
              Нова колекція · Осінь — Зима
            </p>
            <h2 className="text-5xl md:text-6xl font-serif leading-tight mb-6" data-id="element-292" data-mp="1aqbmcvjeem2a">
              Еко шкіра
            </h2>
            <p className="text-brand-cream/70 text-lg leading-relaxed mb-10" data-id="element-293" data-mp="3v3malu8nz2w2">
              Штани з високою посадкою та прямим широким кроєм і спідниця-шорти
              із запахом. М'яка фактура еко шкіри красиво тримає форму — у
              чорному та шоколадному відтінках. Поєднуйте з об'ємним светром
              або мереживним топом.
            </p>
            <a href="#contact" className="inline-flex items-center gap-2 bg-brand-cream text-brand-dark px-7 py-3.5 rounded-full font-medium hover:bg-brand-beige transition-colors" data-id="element-294" data-mp="hnydc4o9ui7o">
              Дізнатися про наявність
              <ArrowRight className="w-4 h-4" data-id="element-295" data-mp="rmnlv6ua2qb9" />
            </a>
          </motion.div>

          {/* Photos */}
          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-296" data-mp="wkfmqqcwhmrl">
            {ecoLeatherPhotos.map(photo => <Photo key={photo.src} photo={photo} className="aspect-[3/4]" data-id="element-297" data-mp="2yckdvzmksg19" />)}
          </div>
        </div>
      </div>
    </section>;
}
interface PhotoProps {
  photo: {
    src: string;
    alt: string;
  };
  className?: string;
}
function Photo({
  photo,
  className = ''
}: PhotoProps) {
  return <div className={`overflow-hidden rounded-2xl bg-brand-cream/5 ${className}`} data-id="element-298" data-mp="309sg080k3avc">
      <img src={photo.src} alt={photo.alt} loading="lazy" className="w-full h-full object-cover photo-grade" data-id="element-299" data-mp="307phezlc89f0" />
    </div>;
}